import { Component } from '@angular/core';

@Component({
    selector: 'profile-ingot',
    templateUrl: 'profile-ingot.component.html',
    styleUrls: ['profile-ingot.component.scss'],
    standalone: false
})
export class ProfileIngotComponent {}
